Wee.fn.make('representative', {
	init: function() {
		var scope = this.$private,
			segments = $.routes.uri().segments,
			lastSegment = segments.slice(-1).toString(),
			hasZipCode = /\d{5}/;

		scope.swapForm();

		if (segments.length > 2 || hasZipCode.test(lastSegment)) {
			scope.getReps(segments.length > 2 ? segments[2] : lastSegment);
		}

		$.screen.map([
			{
				max: 2,
				init: false,
				callback: function() {
					scope.swapText('abbr');
				}
			},
			{
				min: 3,
				callback: function() {
					scope.swapText('full');
				}
			}
		]);
	},

	load: function() {
		this.$private.search();

		this.$private.textState();

		Wee.dropdown.init({
			rootModifier: '-rep'
		});

		$.history.bind({
			click: 'ref:countryText'
		}, {
			partials: '.rep-search',
			scrollTop: false
		});
	}
}, {

	/**
	* Changes text based on screen size
	*
	* @private
	*/
	swapText: function(type) {
		$('ref:countryLabel').each(function(el) {
			var $el = $(el);

			$el.text($el.data(type));
		});
	},

	/**
	 * Toggles text state from active to deactivate
	 *
	 * @private
	 */
	textState: function() {
		var $label = $('ref:countryLabel'),
			$text = $('ref:countryText');

		if ($.routes.segments(1) === 'canada') {
			$label.add($text).deActivate();
			$('ref:countryCanada').activate();
		} else if ($.routes.segments(1) === 'international') {
			$label.add($text).deActivate();
			$('ref:countryInt').activate();
		} else {
			$label.add($text).deActivate();
			$('ref:countryUsa').activate();
		}
	},

	/**
	* Replace form based on country selected
	*
	* @private
	*/
	swapForm: function() {
		$('ref:countryText').on('click', function(e, el) {
			$('ref:countryText').deActivate();
			$('ref:countryLabel').deActivate();

			$(el).activate()
				.find('ref:countryLabel')
				.activate();
		});
	},

	/**
	* Fires event to search for representative based on search parameter
	*
	* @private
	*/
	search: function() {
		var scope = this;

		$('ref:repSearch').on('submit', function(e) {
			scope.getReps($('ref:repInput')[0].value);

			e.preventDefault();
		});
	},

	/**
	* Submits ajax request
	*
	* @private
	*/
	getReps: function(value) {
		var scope = this,
			val = value.toLowerCase(),
			seg = $.routes.segments(1),
			url = '/find-a-rep';

		if (seg == 'canada' || seg == 'international') {
			url += '/' + seg;
		}

		url += '/' + val;

		Wee.data.request({
			root: '/ajax',
			url: url,
			success: function(data) {
				if (history && history.pushState) {
					history.pushState(0, '', url);
				}

				$('ref:rep').html(data);

				$('ref:repInput').val('');

				scope.scrollBody();
			},
			error: function() {
				$('ref:rep').html('<div class="container -events"><h6 class="rep-results__none">No result! Please enter another location.</h6></div>');

				$('ref:repInput').val('');

				scope.scrollBody();
			}
		});
	},

	/**
	* Scrolls page viewpoint to rep listing
	*
	* @private
	*/
	scrollBody: function() {
		var offset = $('ref:rep').offset().top,
			headerHeight = $('ref:siteHeader').height();

		$.animate.tween('body', {
			scrollTop: (offset - headerHeight) + 'px'
		});
	}
});